import AlertWarningPaymentMethodContainer from './alert-warning-payment-method-container';

export default AlertWarningPaymentMethodContainer;
